import api from './api'
import { parseParams, parseUrlFilters } from './common'

export default {
  getUsers (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('users', filters)
    return api.get(`/users?${urlParams}&${urlFilters}`).then(res => res.data)
  },
  getUser ({ id, ...params }) {
    const urlParams = parseParams(params)
    return api.get(`/users/${id}?${urlParams}`).then(res => res.data)
  },
  saveUser (user) {
    const method = user.id ? 'put' : 'post'
    const url = user.id ? `/users/${user.id}` : '/users'
    return api[method](url, user).then(res => res.data)
  },
  deleteUser (id) {
    return api.delete(`/users/${id}`).then(res => res.data)
  },
  resetPassword (email) {
    return api.post('/users/password_reset', { email }).then(res => res.data)
  },
  confirmResetPassword (token, password) {
    return api.put('/users/password_reset', { token, password }).then(res => res.data)
  },
  changePassword ({ id, oldPassword, newPassword }) {
    return this.saveUser({ id, old_password: oldPassword, password: newPassword })
  }
}
